/**
 * Tasks Module Routes — Kanban 2D (PRD 1, EPIC 1.4, Story 1.4.3).
 *
 * Permissions follow V1/backend/app/db/seeds/tasks_permissions_seed.py:
 *   - tasks:read   (used here)
 *   - tasks:create (future create wizard, Story 1.4.6+)
 *   - tasks:update (PATCH /move, used by drag-drop — gated server-side)
 *   - tasks:delete (admin only)
 *
 * Detail page, create wizard and 3D arena ship in later stories.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const TasksPage = lazy(() => import("@/pages/tasks/TasksPage"));

export const tasksRoutes: ModuleRoutes = {
  moduleId: "tasks",
  basePath: "/tasks",
  routes: [
    {
      path: "/tasks",
      element: <TasksPage />,
      permission: { resource: "tasks", action: "read" },
    },
  ],
};
